import * as accounts from 'src/api/accounts'
import {
  GET_ACCOUNT
} from 'src/store/mutation-types'

const getPersonlInformation = ({commit, dispatch}) => {
  dispatch('toggleLoadding', true, {root: true})
  accounts.getPersonlInformation().then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ACCOUNT, response.data)
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

export default{
  getPersonlInformation
}



// WEBPACK FOOTER //
// ./src/components/account/store/actions.js